import StandardJackpot from "./StandardJackpot";

export default StandardJackpot;